export default "__VITE_ASSET__VIKZ456u__"